import type { FederationServiceProvider as FederationServiceProviderModel } from '@/adapters/catalogv1.g';

export function extractFederationServiceProvider(
  model: FederationServiceProviderModel
) {
  const poolRef = model.pool_ref ?? '';
  const providerRef = model.provider_ref ?? '';

  return {
    // Edge entities have no single natural key; prefer the projected
    // distinct_id and fall back to the compound (pool_ref, provider_ref).
    id: model._metadata?.distinct_id ?? `${poolRef}/${providerRef}`,
    ref: `${poolRef}/${providerRef}`,
    poolRef,
    providerRef,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogFederationServiceProvider = ReturnType<
  typeof extractFederationServiceProvider
>;
